(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
    const params = new URLSearchParams(window.location.search);
    const openFilter = params.get('open_filters');
    if (!openFilter) return;

    function openFilterDrawer() {
      const drawer = document.querySelector('#filters-drawer');
      if (!drawer) return;
      if (typeof drawer.showDialog === 'function') {
        drawer.showDialog();
      } else {
        drawer.dispatchEvent(new CustomEvent('dialog-component/showDialog'));
      }

      setTimeout(function () {
        const accordions = drawer.querySelectorAll('accordion-custom[data-filter-param-name]');
        accordions.forEach(function (acc) {
          const paramName = (acc.getAttribute('data-filter-param-name') || '').toLowerCase();
          if (paramName.includes(openFilter.toLowerCase())) {
            const details = acc.querySelector('details');
            if (details && !details.open) details.open = true;
          }
        });
      }, 300);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFilterDrawer);
    } else {
      openFilterDrawer();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
